import type { VerifiedCredentialCategory } from 'src/types/graphql';

import type { Verifiable } from './types';

export const processVerified = (
  verified: VerifiedCredentialCategory[] | null | undefined,
) => {
  const verifiedCredentials = verified?.flatMap(
    (verifiedItem) => verifiedItem.credentials,
  );

  const verifiedCredentialCount = verifiedCredentials?.length;

  return { verified, verifiedCredentialCount };
};

const filterSupportedVerifiable = (
  verifiable: Verifiable | null | undefined,
) => {
  if (!verifiable) {
    return verifiable;
  }
  const supportedVerifiable: Verifiable = [];

  verifiable.forEach((category) => {
    const { credentials, pendingCount } = category;
    const supportedCredentials =
      credentials?.filter(
        (credential) => Object.keys(credential).length !== 0,
      ) ?? [];

    // Only show category if it has credentials or pending count to show
    if (supportedCredentials.length > 0 || (pendingCount && pendingCount > 0)) {
      const supportedCategory = {
        ...category,
        credentials: supportedCredentials,
      };
      supportedVerifiable.push(supportedCategory);
    }
  });

  return supportedVerifiable;
};

export const processVerifiable = (
  verifiable: Verifiable | null | undefined,
) => {
  // Filter out categories with no credentials OR pendingCount
  // This is because graph can implement a new type of credential and the section might be empty
  const filteredVerifiable = filterSupportedVerifiable(verifiable);

  const verifiableCredentials = filteredVerifiable?.flatMap(
    (verifiableItem) => verifiableItem.credentials,
  );
  const verifiableCredentialCount = verifiableCredentials?.length;

  return { verifiable: filteredVerifiable, verifiableCredentialCount };
};
